/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListIssuerConvergenceCandidatesResult,
  ListIssuerConvergenceCandidatesResult$inboundSchema,
} from "../components/listissuerconvergencecandidatesresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListGlobalRemoteSessionIssuerConvergenceCandidatesSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListGlobalRemoteSessionIssuerConvergenceCandidatesRequest = {
  /**
   * The global remote_session_issuer that candidates would be consolidated onto.
   */
  targetId: string;
  /**
   * Pagination cursor.
   */
  cursor?: string | undefined;
  /**
   * Page size (default 50, max 100).
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type ListGlobalRemoteSessionIssuerConvergenceCandidatesResponse = {
  result: ListIssuerConvergenceCandidatesResult;
};

/** @internal */
export type ListGlobalRemoteSessionIssuerConvergenceCandidatesSecurity$Outbound =
  {
    "session_header_Gram-Session"?: string | undefined;
  };

/** @internal */
export const ListGlobalRemoteSessionIssuerConvergenceCandidatesSecurity$outboundSchema:
  z.ZodMiniType<
    ListGlobalRemoteSessionIssuerConvergenceCandidatesSecurity$Outbound,
    ListGlobalRemoteSessionIssuerConvergenceCandidatesSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listGlobalRemoteSessionIssuerConvergenceCandidatesSecurityToJSON(
  listGlobalRemoteSessionIssuerConvergenceCandidatesSecurity:
    ListGlobalRemoteSessionIssuerConvergenceCandidatesSecurity,
): string {
  return JSON.stringify(
    ListGlobalRemoteSessionIssuerConvergenceCandidatesSecurity$outboundSchema
      .parse(listGlobalRemoteSessionIssuerConvergenceCandidatesSecurity),
  );
}

/** @internal */
export type ListGlobalRemoteSessionIssuerConvergenceCandidatesRequest$Outbound =
  {
    target_id: string;
    cursor?: string | undefined;
    limit?: number | undefined;
    "Gram-Session"?: string | undefined;
  };

/** @internal */
export const ListGlobalRemoteSessionIssuerConvergenceCandidatesRequest$outboundSchema:
  z.ZodMiniType<
    ListGlobalRemoteSessionIssuerConvergenceCandidatesRequest$Outbound,
    ListGlobalRemoteSessionIssuerConvergenceCandidatesRequest
  > = z.pipe(
    z.object({
      targetId: z.string(),
      cursor: z.optional(z.string()),
      limit: z.optional(z.int()),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        targetId: "target_id",
        gramSession: "Gram-Session",
      });
    }),
  );

export function listGlobalRemoteSessionIssuerConvergenceCandidatesRequestToJSON(
  listGlobalRemoteSessionIssuerConvergenceCandidatesRequest:
    ListGlobalRemoteSessionIssuerConvergenceCandidatesRequest,
): string {
  return JSON.stringify(
    ListGlobalRemoteSessionIssuerConvergenceCandidatesRequest$outboundSchema
      .parse(listGlobalRemoteSessionIssuerConvergenceCandidatesRequest),
  );
}

/** @internal */
export const ListGlobalRemoteSessionIssuerConvergenceCandidatesResponse$inboundSchema:
  z.ZodMiniType<
    ListGlobalRemoteSessionIssuerConvergenceCandidatesResponse,
    unknown
  > = z.pipe(
    z.object({
      Result: ListIssuerConvergenceCandidatesResult$inboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        "Result": "result",
      });
    }),
  );

export function listGlobalRemoteSessionIssuerConvergenceCandidatesResponseFromJSON(
  jsonString: string,
): SafeParseResult<
  ListGlobalRemoteSessionIssuerConvergenceCandidatesResponse,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListGlobalRemoteSessionIssuerConvergenceCandidatesResponse$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'ListGlobalRemoteSessionIssuerConvergenceCandidatesResponse' from JSON`,
  );
}
